import Vue from 'vue'
import App from './App.vue'
import Request from "./base_js/Request";
import store from "./store"
import VueRouter from "vue-router";
import router from "./router/index"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import el from "element-ui/src/locale/lang/el";
Vue.config.productionTip = false
Vue.prototype.$request = Request
Vue.use(VueRouter)
Vue.use(ElementUI);

const MATERIAL_COLLABORATOR_ACCOUNT_TYPE = "material_collaborator"
const MATERIAL_COLLABORATOR_ALLOW_ROUTE_NAMES = ["imageManage", "audioPackManager", "materialStatistics", "searchKeywordAnalysis"]

function getUserInfoFromStorage() {
  let userInfo = null;
  try {
    const storageData = localStorage.getItem(process.env.VUE_APP_USER_KEY);
    if (storageData) {
      const parsed = JSON.parse(storageData);
      if (parsed.expireTime) {
        if (new Date().getTime() > parsed.expireTime) {
          localStorage.removeItem(process.env.VUE_APP_USER_KEY);
          userInfo = null;
        } else {
          userInfo = parsed.userInfo;
        }
      } else {
        userInfo = parsed;
      }
    }
  } catch (error) {
    console.error('解析用户信息失败:', error);
    localStorage.removeItem(process.env.VUE_APP_USER_KEY);
    userInfo = null;
  }
  return userInfo;
}

function isMaterialCollaborator(userInfo) {
  return userInfo && userInfo.accountType === MATERIAL_COLLABORATOR_ACCOUNT_TYPE;
}

router.beforeEach((to, from, next) => {
  const userInfo = getUserInfoFromStorage();

  if (process.env.NODE_ENV === 'development' && to.path === "/") {
    next('/login')
    return
  }

  //路由验证,当前是登录时，放行
  if (to.path ==="/" || to.path === "/login" || to.path === "/detail"){
      // chrome
      document.body.scrollTop = 0
      // firefox
      document.documentElement.scrollTop = 0
      // safari
      window.pageYOffset = 0
      next()
  }else {
    if (userInfo !== null){
      // chrome
      document.body.scrollTop = 0
      // firefox
      document.documentElement.scrollTop = 0
      // safari
      window.pageYOffset = 0
      if (to.name === "index" && isMaterialCollaborator(userInfo)) {
        next({name: "imageManage"})
        return
      }
      if (isMaterialCollaborator(userInfo) && to.name && !MATERIAL_COLLABORATOR_ALLOW_ROUTE_NAMES.includes(to.name)) {
        next({name: "imageManage"})
        return
      }
      next()
    }else {
      next('/login')
    }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const vue = new Vue({
  render: h => h(App),
  store,
  router: router,
  beforeCreate() {
    //添加事件总线
    Vue.prototype.$bus = this
  }
}).$mount('#app');
export default vue
